<template>
  <div>
    <div
      class="p-4 col-12"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <h1
        class="p-0, m-0"
        style="font-size: 25px; text-transform: uppercase; font-weight: 700"
      >
        Virtual Accounts
      </h1>
      <router-link
        class="btn btn-info m-2"
        :to="`/dashboard/ptsp-terminals`"
        style="width: min-content"
      >
        Back To Terminal
      </router-link>
    </div>

    <div class="col-12 p-0">
      <card class="card-plain p-0">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Bank Name</th>
                <th scope="col" class="text-center">Account Name</th>
                <th scope="col" class="text-center">Account Number</th>
                <th scope="col" class="text-center">Terminal ID</th>
                <th scope="col" class="text-center">Terminal Type</th>
                <th scope="col" class="text-center">Date Created</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(terminal, index) in accounts" :key="terminal._id">
                <th class="text-center">{{ index + 1 }}</th>
                <td class="text-center">{{ terminal.bankName }}</td>
                <td class="text-center">{{ terminal.accountName }}</td>
                <td class="text-center">{{ terminal.accountNumber }}</td>
                <td class="text-center">{{ terminal.terminalId }}</td>
                <td class="text-center">{{ terminal.terminalType || "--" }}</td>
                <td class="text-center">
                  {{ formatDate(terminal.createdAt) || "--" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      error: false,
      errorMsg: "",
      accounts: [],
      moment,
    };
  },

  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD, hh:mm:ss");
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/terminals/linked-account`,
        {
          terminalId: this.$route.params.terminalId,
        },
      );

      this.accounts = res.data.accounts;
    } catch (err) {
      console.log(err);
      this.error = true;

      this.errorMsg = "Unable to Fetch Virtual Accounts";
    }
  },
};
</script>
